import React, { Fragment } from 'react';
import { Quick as Tooltip } from './Tooltip';
export function DisabledWithTooltip({ isDisabled, position, reason, children, tooltipWidth = 200, }) {
    const MaybeTooltip = isDisabled ? Tooltip : Fragment;
    return (React.createElement(MaybeTooltip, { cursor: isDisabled ? 'default' : 'pointer', content: reason, maxWidth: tooltipWidth, side: position }, children));
}
